import {type ChangeEvent, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

interface AreasInterestProps {
    areasInterestData: string,
    checked: { [p: string]: boolean },
    handleCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

const AreasInterest = ({areasInterestData, checked, handleCheckboxChange}: AreasInterestProps) => {
    const {t} = useTranslation("ui");

    const data = areasInterestData.split(",").map(name => name.trim());
    if (data.length == 1 && data[0] == "") {
        data.pop();
    } else {
        data.push("ETC");
    }

    const [otherValue, setOtherValue] = useState("");

    const onChangeOtherValue = (e: ChangeEvent<HTMLInputElement>) => {
        if (data.length == 0 || checked["ETC"]) {
            setOtherValue(e.target.value);
        }
    }

    useEffect(() => {
        if (checked["ETC"]) {
            setOtherValue("");
        }
    }, [checked]);

    return (
        <div className="card rounded-4 p-4 mb-4">
            <h5 className="pb-4 col subheadings">{t("signUp.interests")}</h5>
            <div className="d-flex flex-wrap align-items-center">
                {
                    data.map((item, i) => (
                        // 1. 각 항목의 최상위 div 클래스를 'form-check'로 변경합니다.
                        // 2. 조건부 마진(ms-4)은 그대로 유지합니다.
                        <div key={item} className={`form-check${i > 0 ? " ms-4" : ""}`}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name={item}
                                // 3. label과 연결하기 위해 고유한 id를 부여합니다.
                                id={`checkbox-${item}-${i}`}
                                checked={checked[item] ?? false}
                                onChange={handleCheckboxChange}
                            />
                            {/* 4. span 대신 label을 사용하고, htmlFor로 input의 id와 연결합니다. */}
                            <label
                                className="form-check-label"
                                htmlFor={`checkbox-${item}-${i}`}
                            >
                                {item}
                            </label>
                        </div>
                    ))
                }
            </div>
            {
                (data.length == 0 || checked["ETC"]) &&
                <div className="d-flex align-items-center mt-3">
                    <span style={{whiteSpace: "nowrap"}}>{t("signUp.otherInterests")}</span>
                    <input type="text"
                           name="interests"
                           value={otherValue}
                           className="form-control rounded-3 bg-light px-4 ms-3"
                           onChange={onChangeOtherValue}
                           placeholder={t("signUp.otherInterestsPlaceholder")}
                           disabled={data.length > 0 && !checked["ETC"]}/>
                </div>
            }
        </div>
    )
}

export default AreasInterest;